import React from 'react'
import styled from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'

export const Wrapper = styled.div`
  background-color: ${colors.light2};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  ${fonts.libreBaskerville};
  padding: 20px 0;
`

export const Title = styled.div`
  color: ${colors.darkPurple};
  width: 100%;
  text-align: center;
  font-size: 28px;
  margin: 20px 0px;
`

export const Options = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  padding-left: 30px;
  justify-content: center;
  flex-wrap: wrap;
  > div {
    margin-right: 30px;
    margin-bottom: 30px;
  }
`

export default props => (
  <Wrapper>
    <Title>{props.isSubscribed ? 'Upgrade your subscription' : 'Select your plan'}</Title>
    <Options>
      <Button size='large' onClick={() => props.onSelectOneClass()}>One class</Button>
      <Button size='large' onClick={() => props.onSelectMultipleClasses()}>Multiple classes</Button>
      <Button size='large' onClick={() => props.onSelectWholeSchool()}>Whole school</Button>
      <Button size='large' onClick={() => props.onSelectMultipleSchools()}>Multiple schools</Button>
    </Options>
  </Wrapper>
)
